<script setup>
import Layout from "./Authenticated.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";

const props = defineProps([
    'flash',
]);

const toast = useToast()

onMounted(() => {
    if (props.flash?.severity) {
        toast.add({
            severity: props.flash.severity,
            summary: props.flash.value,
            life: 5000,
        });
    }
})

</script>
<template>
    <Layout>
        <div class="lato max-w-7xl mx-auto p-4 my-10">
            <div class="text-xl font-bold mb-7">Admin</div>
            <div class="flex gap-[3em] mx-auto pb-14">
                <nav class="max-w-[250px]">
                    <li class="text-black list-none mb-4">
                        <Link href="/admin/users"
                              :class="{
                                'font-bold': $page.url.startsWith('/admin/users')
                              }">
                            Benutzer
                        </Link>
                    </li>
                    <li class="text-black list-none mb-4">
                        <Link href="/admin/notifications"
                              :class="{
                                'font-bold': $page.url.startsWith('/admin/notifications')
                              }">
                            Notifications
                        </Link>
                    </li>
                    <li class="text-black list-none mb-4">
                        <Link href="/admin/subscriptions"
                              :class="{
                                'font-bold': $page.url.startsWith('/admin/subscriptions')
                              }">
                            Abonnements
                        </Link>
                    </li>
                    <li class="text-black list-none mb-4">
                        <Link href="/admin/stale-measurements"
                              :class="{
                                'font-bold': $page.url.startsWith('/admin/stale-measurements')
                              }">
                            Veraltete Messungen
                        </Link>
                    </li>
                    <li class="text-black list-none mb-4">
                        <Link href="/admin/alerts/sent"
                              :class="{
                                'font-bold': $page.url.startsWith('/admin/alerts')
                              }">
                            Erinnerungen
                        </Link>
                        <ul v-if="$page.url.startsWith('/admin/alerts')" class="ml-4 mt-2">
                            <li class="mb-2">
                                <Link href="/admin/alerts/sent"
                                      :class="{
                                        'font-bold': $page.url.startsWith('/admin/alerts/sent')
                                      }">
                                    Gesendete
                                </Link>
                            </li>
                            <li class="mb-2">
                                <Link href="/admin/alerts/settings"
                                      :class="{
                                        'font-bold': $page.url.startsWith('/admin/alerts/settings')
                                      }">
                                    Einstellungen
                                </Link>
                            </li>
                        </ul>
                    </li>
                </nav>

                <div class="flex-1">
                    <div class="bg-white rounded">
                        <slot />
                    </div>
                </div>
            </div>
        </div>
        <Toast />
    </Layout>
</template>
